import { ArrowUpRight, Check, Copy, ExternalLink, Lock, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BuyPlatformMark } from "@/components/PlatformLinks";

const STEPS = [
  { title: "COPY", text: "Copy the official $KBULL Solana address.", Icon: Copy },
  { title: "OPEN", text: "Open your preferred supported Solana trading platform or wallet.", Icon: ExternalLink },
  { title: "VERIFY & BUY", text: "Paste the address, verify that it matches the official $KBULL token, then complete your swap.", Icon: ShieldCheck },
];
const SAFETY = ["Use only the contract address displayed on KINGBULLISH", "Verify the Solana network", "Never share your seed phrase", "KINGBULLISH will never ask for your private key", "Beware of fake tokens and impersonators"];

export const BuySteps = () => (
  <section className="buy-steps" aria-labelledby="buy-steps-heading" data-testid="buy-steps">
    <h2 id="buy-steps-heading" className="buy-section-title" data-testid="buy-steps-heading">HOW TO BUY $KBULL</h2>
    <ol className="buy-steps__list">{STEPS.map(({ title, text, Icon }, i) => (
      <li key={title} data-testid={`buy-step-${i + 1}`}>
        <span className="buy-step-number" aria-hidden="true">0{i + 1}</span>
        <div><h3 data-testid={`buy-step-${i + 1}-title`}><Icon aria-hidden="true" />{title}</h3><p data-testid={`buy-step-${i + 1}-description`}>{text}</p></div>
      </li>
    ))}</ol>
  </section>
);

export const BuyPlatforms = ({ platforms, title, sectionId }) => (
  <section aria-labelledby={`${sectionId}-heading`} className="buy-platforms" data-testid={sectionId}>
    <h2 className="buy-section-title" id={sectionId} data-testid={`${sectionId}-heading`}>{title}</h2>
    <div className="buy-platforms__grid">{platforms.map(({ id, name, image, url, actionLabel }) => (
      <article className="buy-platform" key={id} data-testid={`buy-platform-${id}`} data-configured={Boolean(url)}>
        <BuyPlatformMark platform={{ id, image }} />
        <div className="buy-platform__body"><h3 data-testid={`buy-platform-${id}-name`}>{name}</h3>
          {url ? <Button asChild className="buy-platform__open"><a href={url} target="_blank" rel="noopener noreferrer" data-testid={`buy-platform-${id}-open`} aria-label={`Open ${name} in a new tab`}>{actionLabel} <ArrowUpRight aria-hidden="true" /></a></Button>
            : <Button className="buy-platform__open" disabled data-testid={`buy-platform-${id}-open`} title="Official link available at launch"><Lock aria-hidden="true" /> OPEN</Button>}
        </div>
      </article>
    ))}</div>
  </section>
);

export const BuySecurity = () => (
  <section className="buy-security" aria-labelledby="buy-security-heading" data-testid="buy-security">
    <ShieldCheck className="buy-security__shield" aria-hidden="true" />
    <div><h2 id="buy-security-heading" data-testid="buy-security-heading">VERIFY BEFORE YOU BUY</h2>
      <ul>{SAFETY.map((text, i) => <li key={text} data-testid={`buy-security-rule-${i + 1}`}><Check aria-hidden="true" /><span>{text}</span></li>)}</ul>
    </div>
  </section>
);